import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionSubmoduleRow } from "../types";

const ModuleVersionSubmodulesTableNameCell = ({
  item: submodule,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionSubmoduleRow>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./../submodule/${encodeURIComponent(submodule.id)}`}>
        {submodule.id}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ModuleVersionSubmodulesTableNameCell;
